import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, eur } from "../../lib/api";
import { PROPERTY_STATUS, STATUS_COLORS, fmtDate } from "../../lib/re";
import { Building2, KeyRound, UserCheck, FileWarning, Home, Landmark } from "lucide-react";

const Tile = ({ icon: Icon, label, value, sub, to, testId }) => (
  <Link to={to} data-testid={testId} className="card-almar p-4 flex items-center gap-3 transition-transform hover:-translate-y-0.5">
    <span className="w-10 h-10 rounded-lg bg-[#C9A84C]/15 flex items-center justify-center text-[#C9A84C] flex-shrink-0"><Icon size={18} /></span>
    <div className="min-w-0"><p className="text-xl font-bold text-slate-100 truncate">{value}</p><p className="text-[11px] text-slate-400 leading-snug">{label}{sub ? ` · ${sub}` : ""}</p></div>
  </Link>
);

export function PortfolioPanel() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/re/stats").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const docs = s.docs;
  return (
    <section className="mb-8" data-testid="portfolio-panel">
      <h3 className="font-display text-lg text-[#C9A84C] mb-3">Carteira Imobiliária</h3>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Tile icon={Building2} label="Imóveis em carteira" value={s.total} to="/imoveis" testId="pf-total" />
        <Tile icon={Landmark} label="Valor da carteira" value={eur(s.portfolio_value)} to="/imoveis" testId="pf-value" />
        <Tile icon={Home} label="Disponíveis venda / arrendamento" value={`${s.available_sale} / ${s.available_rent}`} to="/imoveis" testId="pf-available" />
        <Tile icon={KeyRound} label="Proprietários" value={s.owners_total} sub={`${s.new_owners} novos (30 dias)`} to="/proprietarios" testId="pf-owners" />
        <Tile icon={UserCheck} label="Compradores / arrendatários" value={`${s.buyers} / ${s.tenants}`} to="/clientes" testId="pf-clients" />
        {docs && <Tile icon={FileWarning} label="Documentos em falta" value={docs.missing_total} sub={`${docs.expired} expirados · ${docs.expiring} a expirar`} to="/documentacao" testId="pf-docs" />}
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 mt-4">
        <div className="card-almar p-5" data-testid="pf-status">
          <p className="text-sm font-semibold text-slate-100 mb-3">Imóveis por estado</p>
          <div className="flex flex-wrap gap-2">
            {Object.entries(s.by_status).map(([k, v]) => (
              <Link key={k} to="/imoveis" className={`px-3 py-1.5 rounded-lg border text-xs ${STATUS_COLORS[k]}`}>{PROPERTY_STATUS[k]} <b className="ml-1">{v}</b></Link>
            ))}
          </div>
        </div>
        <div className="card-almar p-5" data-testid="pf-recent">
          <p className="text-sm font-semibold text-slate-100 mb-3">Angariações recentes <span className="text-xs text-slate-500">({s.recent_count} nos últimos 30 dias)</span></p>
          {s.recent_acquisitions.length === 0 ? <p className="text-xs text-slate-500">Sem angariações recentes.</p> : s.recent_acquisitions.map((p) => (
            <Link key={p.id} to={`/imoveis/${p.id}`} className="flex justify-between gap-3 py-1.5 text-sm border-b border-[#1E3A56]/50 last:border-0">
              <span className="text-slate-200 truncate"><span className="font-mono text-[11px] text-slate-500 mr-2">{p.reference}</span>{p.title}</span>
              <span className="text-xs text-slate-400 whitespace-nowrap">{fmtDate(p.acquisition_date)}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
